import { InteractionRequiredAuthError } from '@azure/msal-browser';
import axios from 'axios';
import { useEffect } from 'react';
import { loginRequest } from './auth/config/authConfig';
import { msalInstance } from './auth/userAccount';
import { useAppState } from './context/appContext';
import { useErrorContext } from './context/errorContext';
import { env } from './env';

const AxiosInterceptor = () => {
  const { setLoading } = useAppState();
  const { setError } = useErrorContext();

  useEffect(() => {
    axios.defaults.baseURL = env.REACT_APP_API_URL;

    axios.interceptors.request.use(
      async (config) => {
        if (config.loaderRequired === undefined || config.loaderRequired === 'undefined') {
          setLoading(true);
        } else {
          setLoading(false);
        }

        setError(null);

        // May need to re-add
        //setError(null);

        const account = msalInstance.getAllAccounts()[0];
        const msalResponse = await msalInstance
          .acquireTokenSilent({
            ...loginRequest,
            account: account,
          })
          .catch(async (error) => {
            setLoading(false);

            if (error instanceof InteractionRequiredAuthError) {
              // fallback to interaction when silent call fails
              const msalPopupResponse = await msalInstance.acquireTokenRedirect(loginRequest);
              const popupToken = msalPopupResponse?.accessToken;
              if (popupToken) {
                config.headers['Authorization'] = `Bearer ${popupToken}`;
              }

              return config;
            }
            // handle other errors
          });

        const token = msalResponse.accessToken;

        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
      },
      (error) => {
        throw error;
      }
    );

    axios.interceptors.response.use(
      (response) => {
        if (response.data.errors?.length > 0) {
          console.log(response.data.errors);
          setError({ response });
        }
        setLoading(false);
        return response;
      },
      (error) => {
        console.log(error);
        setLoading(false);
        setError(error);
        throw error;
      }
    );
  });
};

export { AxiosInterceptor };

